// extracted by mini-css-extract-plugin
export default {"eventContainer":"DashboardCalendar_eventContainer__Gyihf","invisibleToggle":"DashboardCalendar_invisibleToggle__rQTYA","visibleToggle":"DashboardCalendar_visibleToggle__8lqAE"};